export default __webpack_public_path__ + "static/media/paiementweb.26a402be.gif";